import { Box, Flex, FormControl, FormErrorMessage, FormHelperText, FormLabel, Input, Spinner } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useDebouncedSave } from "../../../../../../common/input/useDebouncedSave";
import { useTranslation } from "react-i18next";
import { useAppDispatch } from "../../../../../../common/redux/hooks";
import { containsError } from "../../../../../../common/redux/reducers/contractReducer";
import { editContractThunk } from "../../../../../../common/redux/thunks/contract/edit-contract-thunk";
import { useContractState } from "../../../useContractState";
import { RemoveDataFieldButton } from "../RemoveDataFieldButton";

interface Props {
  removeDataField?: () => Promise<void>;
  isRequiredButNotProvided: boolean;
}

export const ExternalLink = ({ removeDataField, isRequiredButNotProvided }: Props) => {
  const { t } = useTranslation();
  const contractState = useContractState();
  const [isLoading, setIsLoading] = useState(false);
  const errorMessage = containsError(contractState, "EditExternalLink") ? t("Update failed") : null;
  const dispatch = useAppDispatch();
  const [link, setLink] = useState<string>();

  useEffect(() => {
    if (contractState.contract.dataFields?.externalLink) {
      setLink(contractState.contract.dataFields.externalLink);
    }
  }, []);

  const eventHandler = async (value: string) => {
    setIsLoading(true);
    await dispatch(
      editContractThunk({
        command: {
          type: "EditExternalLink",
          value: value,
        },
      })
    );
    setIsLoading(false);
  };
  const debouncedEventHandler = useDebouncedSave(eventHandler);

  return (
    <FormControl isInvalid={errorMessage !== null} isRequired={isRequiredButNotProvided}>
      <FormLabel htmlFor={"value"}>
        {t("External link")} {isLoading && <Spinner size="xs" />}
      </FormLabel>
      <Flex w="100%">
        <Box borderRadius={"10px"} backgroundColor="smBackground" w="100%">
          <Input
            type="text"
            value={link ?? ""}
            onChange={(e) => {
              setLink(e.target.value);
              debouncedEventHandler(e.target.value);
            }}
          />
        </Box>
        <RemoveDataFieldButton removeDataField={removeDataField} />
      </Flex>
      <FormHelperText>{t("Provide external link")}</FormHelperText>
      <FormErrorMessage>{errorMessage && errorMessage}</FormErrorMessage>
    </FormControl>
  );
};
